import cn from 'classnames';
import { InteractiveDiv } from '@Components/InteractiveEl';
import { SectionStatus, SectionStatusType } from '../data-qa-constants';

interface StageOption {
  key: string;
  label: string;
  // Shown as a badge once the stage is approved or flagged. Omitted where a stage has no
  // review of its own (e.g. priors).
  status?: SectionStatusType;
}

interface StageSwitcherProps {
  // e.g. "This model has two stages — choose one to view its priors:"
  prompt: string;
  stages: StageOption[];
  activeIndex: number;
  onSelect: (index: number) => void;
}

// Brand Equity's stage picker (GQV / Total Business, etc.), the same on every tab that
// splits by stage. A bold prompt over a solid brand-filled active pill on a tinted track,
// so it reads as a control to interact with, not more static page content to skim past.
export const StageSwitcher = ({ prompt, stages, activeIndex, onSelect }: StageSwitcherProps) => (
  <div className='data-qa-stage-switcher'>
    <span className='data-qa-stage-switcher__prompt'>{prompt}</span>
    <div className='data-qa-stage-switcher__track'>
      {stages.map((stage, index) => (
        <InteractiveDiv
          key={stage.key}
          className='data-qa-stage-switcher__tab'
          aria-pressed={index === activeIndex}
          disabled={index === activeIndex}
          onClick={() => onSelect(index)}
        >
          {stage.label}
          {stage.status && stage.status !== SectionStatus.UNREVIEWED && (
            <span
              className={cn(
                'data-qa-stage-switcher__badge',
                `data-qa-stage-switcher__badge--${stage.status}`
              )}
            >
              {stage.status === SectionStatus.APPROVED ? 'Approved' : 'Flagged'}
            </span>
          )}
        </InteractiveDiv>
      ))}
    </div>
  </div>
);
